import { RecentActivity } from '../models/activitiy';
import { RecentEarningAndLossActivityGroup } from '../models/dashboard';

const getRandomTime = (start: Date, end: Date) => {
  return new Date(
    start.getTime() + Math.random() * (end.getTime() - start.getTime())
  );
};

const today = new Date();
const yesterday = new Date();
yesterday.setDate(today.getDate() - 1);
const lastWeek = new Date();
lastWeek.setDate(today.getDate() - 7);

const generateDescription = (
  action: string,
  shares: number,
  symbol: string,
  price: number
) => {
  let verb;

  switch (action) {
    case 'buy':
      verb = 'Purchased';
      break;
    case 'sell':
      verb = 'Disposed of';
      break;
    case 'long':
      verb = 'Went long on';
      break;
    case 'short':
      verb = 'Shorted';
      break;
    default:
      verb = action;
  }

  return `${verb} ${shares} shares of ${symbol} at $${price} per share.`;
};

export const DUMMY_RECENT_ACTIVITIES: RecentActivity[] = [
  {
    activities: [
      {
        createdAt: getRandomTime(today, new Date()),
        link: '',
        icon: '',
        description: generateDescription('sell', 100, 'Apple Inc. (APPL)', 500),
      },
      {
        createdAt: getRandomTime(today, new Date()),
        link: '',
        icon: '',
        description: generateDescription('buy', 50, 'Amazon Inc. (AMZN)', 1500),
      },
      {
        createdAt: getRandomTime(today, new Date()),
        link: '',
        icon: '',
        description: generateDescription('long', 25, 'Tesla Inc. (TSLA)', 800),
      },
    ],
    groupName: 'Today',
  },
  {
    activities: [
      {
        createdAt: getRandomTime(yesterday, today),
        link: '',
        icon: '',
        description: generateDescription(
          'sell',
          75,
          'Netflix Inc. (NFLX)',
          600
        ),
      },
      {
        createdAt: getRandomTime(yesterday, today),
        link: '',
        icon: '',
        description: generateDescription(
          'buy',
          30,
          'Google Inc. (GOOGL)',
          2000
        ),
      },
    ],
    groupName: 'Yesterday',
  },
  {
    activities: [
      {
        createdAt: getRandomTime(lastWeek, yesterday),
        link: '',
        icon: '',
        description: generateDescription(
          'short',
          40,
          'Microsoft Corp. (MSFT)',
          300
        ),
      },
      {
        createdAt: getRandomTime(lastWeek, yesterday),
        link: '',
        icon: '',
        description: generateDescription('sell', 15, 'Facebook Inc. (FB)', 350),
      },
    ],
    groupName: 'Last Week',
  },
];

const generateEarningAndLossDescription = (amount: number, stock: string) => {
  const formattedAmount = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);

  let verb;
  if (amount >= 0) verb = 'gained';
  else verb = 'lost';

  return `You ${verb} ${formattedAmount} on `;
};

export const DUMMY_EARNING_AND_LOSS: RecentEarningAndLossActivityGroup[] = [
  {
    groupName: 'Today',
    activities: [
      {
        createdAt: getRandomTime(today, new Date()),
        amount: 1023,
        stock: 'Google Inc. (GOOGL)',
        description: generateEarningAndLossDescription(
          1023,
          'Google Inc. (GOOGL)'
        ),
      },
      {
        createdAt: getRandomTime(today, new Date()),
        amount: -500,
        stock: 'Apple Inc. (AAPL)',
        description: generateEarningAndLossDescription(
          -500,
          'Apple Inc. (AAPL)'
        ),
      },
    ],
  },
  {
    groupName: 'Yesterday',
    activities: [
      {
        createdAt: getRandomTime(yesterday, today),
        amount: 1200,
        stock: 'Amazon Inc. (AMZN)',
        description: generateEarningAndLossDescription(
          1200,
          'Amazon Inc. (AMZN)'
        ),
      },
      {
        createdAt: getRandomTime(yesterday, today),
        amount: -300,
        stock: 'Netflix Inc. (NFLX)',
        description: generateEarningAndLossDescription(
          -300,
          'Netflix Inc. (NFLX)'
        ),
      },
    ],
  },
];
